import React, { useState, useEffect, useCallback, useRef } from "react";
import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card, useMediaQuery } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useParams,useLocation } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { colors } from "components/Theme/WebTheme";
import { MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { makeStyles } from "@mui/styles";
import GoBackButton from "components/GoBackButton";
import { getLangKey } from "common/src/other/getLangKey";

const useStyles = makeStyles((theme) => ({
  typography: {
    fontFamily: FONT_FAMILY,
  },
  textField: {
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  selectField: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
  },
  rootRtl: {
    "& label": {
      right: 0,
      left: "auto",
      paddingRight: 20,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 37,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  rootRtl_2: {
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
      fontFamily: FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  selectField_rtl_2: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20,
      fontFamily: FONT_FAMILY,
    },
  },
  selectField_rtl_1: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
      fontFamily: FONT_FAMILY,
    },
  },

  selectField_rtl: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
      fontFamily: FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 15,
      fontFamily: FONT_FAMILY,
    },
  },

  right: {
    textAlign: "right",
    right: 0,
    left: "auto",
    paddingRight: 40,
    fontFamily: FONT_FAMILY,
  },
}));

const EditCar = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editCar, editCarUnique, updateUserCar, consultarPlaca } = api;
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [driversObj, setDriversObj] = useState("");
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [role, setRole] = useState(null);
  const userdata = useSelector((state) => state.usersdata);
  const [drivers, setDrivers] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const carlistdata = useSelector((state) => state.carlistdata);
  const [driverData, setDriverData] = useState(null);
  const [data, setData] = useState(null);
  const [oldData, setOldData] = useState(null);
  const [carTypeAvailable, setCarTypeAvailable] = useState(null);
  const [carData, setCardata] = useState();
  const [loading, setLoading] = useState(false);
  const [placaLoading, setPlacaLoading] = useState(false);
  const [placaFilled, setPlacaFilled] = useState(false);
  const integrationDetails = useSelector((state) => state.integrationdata.integrationDetails);
  const classes = useStyles();
  const isMidScreen = useMediaQuery('(max-width:1199px)');
  const {state}=useLocation()

  useEffect(() => {
    if (id) {
      if (carlistdata && carlistdata.cars) {
        const carData = carlistdata.cars.filter(
          (item) => item.id === id.toString()
        )[0];
        if (!carData) {
          navigate("/404");
        }
        setData(carData);
        setOldData(carData);
      }
    } else {
      setData({
        createdAt: new Date().getTime(),
        car_image:
          "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
        vehicleNumber: "",
        vehicleMake: "",
        carType: "",
        driver: auth && auth.profile.usertype === "driver" ? auth.profile.uid : "",
        vehicleModel: "",
        other_info: "",
        placa: "",
        vehicleColor: "",
        manufactureYear: "",
        city: "",
        active: false,
      });
    }
  }, [carlistdata,id, navigate, auth]);

  useEffect(() => {
    if (carlistdata.cars) {
      setCardata(carlistdata.cars);
    } else {
      setCardata([]);
    }
  }, [carlistdata.cars]);

  useEffect(() => {
    const checkCar = cartypes?.cars.filter(
      (item) => item.name === oldData?.carType
    )[0];
    if (checkCar) {
      setCarTypeAvailable(true);
    } else {
      setCarTypeAvailable(false);
    }
  }, [cartypes, oldData]);

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin
              ? user.mobile
              : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
      setFleetMapObj(obj2);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
    t,
  ]);

  useEffect(() => {
    setDriverData(
      auth.profile.firstName +
      " " +
      auth.profile.lastName +
      " (" +
      (settings.AllowCriticalEditsAdmin
        ? auth.profile.mobile
        : t("hidden_demo")) +
      ") " +
      (settings.AllowCriticalEditsAdmin
        ? auth.profile.email
        : t("hidden_demo"))
    );
  }, [
    auth.profile.lastName,
    auth.profile.mobile,
    auth.profile.email,
    settings.AllowCriticalEditsAdmin,
    auth.profile.firstName,
    t,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value);
  };
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handelChangeDriver = (event) => {
    setData({ ...data, driver: getKeyByValue(driversObj, event.target.value) });
  };
  const handelChangeCarType = (event) => {
    setData({ ...data, carType: event.target.value });
  };
  const handleInputChange = (e) => {
    setData({ ...data, [e.target.id]: e.target.value });
  };

  // ─── Consulta de placa: auto-preenchimento via API (igual ao nvcity) ───────
  const normalize = (s) =>
    String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim();

  const mapFuelType = (combustivel) => {
    const c = normalize(combustivel);
    if (!c) return "";
    if (c.includes("flex") || (c.includes("alcool") && c.includes("gasolina"))) return "alcool_gasolina_flex";
    if (c.includes("alcool") || c.includes("etanol")) return "alcool_etanol";
    if (c.includes("gasolina")) return "gasolina";
    if (c.includes("diesel")) return "diesel";
    if (c.includes("gnv") || c.includes("gas natural")) return "gas_natural_gnv";
    if (c.includes("hidrog")) return "hidrogenio";
    if (c.includes("elet")) return "eletrico";
    return "";
  };

  const UF_TO_STATE_KEY = {
    AC: "acre_ac", AL: "alagoas_al", AP: "amapa_ap", AM: "amazonas_am", BA: "bahia_ba",
    CE: "ceara_ce", DF: "distrito_federal_df", ES: "espirito_santo_es", GO: "goias_go",
    MA: "maranhao_ma", MT: "mato_grosso_mt", MS: "mato_grosso_do_sul_ms", MG: "minas_gerais_mg",
    PA: "para_pa", PB: "paraiba_pb", PR: "parana_pr", PE: "pernambuco_pe", PI: "piaui_pi",
    RJ: "rio_de_janeiro_rj", RN: "rio_grande_do_norte_rn", RS: "rio_grande_do_sul_rs",
    RO: "rondonia_ro", RR: "roraima_rr", SC: "santa_catarina_sc", SP: "sao_paulo_sp",
    SE: "sergipe_se", TO: "tocantins_to",
  };
  const mapStateUF = (uf) => UF_TO_STATE_KEY[String(uf || "").trim().toUpperCase()] || "";

  const mapBodywork = (carroceria) => {
    const c = normalize(carroceria);
    if (!c || c.includes("nao aplicavel")) return "nao_aplicavel";
    if (c.includes("granel")) return "granelera";
    if (c.includes("conteiner") || c.includes("container")) return "porta_conteiner";
    if (c.includes("sider")) return "sider";
    if (c.includes("bau") || c.includes("fechad")) return "fechada_bau";
    if (c.includes("aberta") || c.includes("aberto")) return "aberta";
    return "";
  };

  const mapVehicleType = (especie) => {
    const c = normalize(especie);
    if (!c) return "";
    if (c.includes("passageiro")) return "passageiro";
    if (c.includes("carga")) return "carga";
    if (c.includes("misto")) return "misto";
    if (c.includes("especial")) return "especial";
    if (c.includes("tracao")) return "tracao";
    if (c.includes("semirreboque") || c.includes("semi reboque")) return "semirreboque";
    if (c.includes("reboque")) return "reboque";
    return "";
  };

  const lastQueriedPlaca = useRef("");

  const handlePlacaChange = useCallback(async (e) => {
    const raw = e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
    setPlacaFilled(false);
    setData((prev) => ({ ...prev, placa: raw }));

    if (raw.length >= 7 && raw !== lastQueriedPlaca.current) {
      lastQueriedPlaca.current = raw;
      setPlacaLoading(true);
      try {
        const result = await consultarPlaca(raw, integrationDetails, auth?.profile?.uid);
        if (result && (result.MARCA || result.marca)) {
          const extra = result.extra || {};
          setData((prev) => ({
            ...prev,
            vehicleMake:  result.MARCA || result.marca   || prev.vehicleMake,
            vehicleModel: result.MODELO || result.modelo || prev.vehicleModel,
            vehicleColor: result.cor                     || prev.vehicleColor,
            version:      result.VERSAO                  || prev.version,
            renavam:      extra.renavam || prev.renavam  || "",
            chassis:      extra.chassi || result.chassi  || prev.chassis,
            state:        mapStateUF(extra.uf_placa || extra.uf || result.uf) || prev.state,
            fuel:         mapFuelType(extra.combustivel)       || prev.fuel,
            bodywork:     mapBodywork(extra.tipo_carroceria)   || prev.bodywork,
            vehicleType:  mapVehicleType(extra.especie)        || prev.vehicleType,
            manufactureYear: result.ano || result.anoModelo || extra.ano_fabricacao || extra.ano_modelo || prev.manufactureYear,
            city:         result.municipio || extra.municipio   || prev.city,
          }));
          setPlacaFilled(true);
        }
      } catch (err) {
        // silenciar erro
      } finally {
        setPlacaLoading(false);
      }
    } else if (raw.length < 7) {
      lastQueriedPlaca.current = "";
    }
  }, [consultarPlaca, integrationDetails, auth?.profile?.uid]);

  const updateCar = () => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
        setLoading(true);
        setTimeout(async () => {
          resolve();
          if (data !== oldData) {
            data['fleetadmin'] = data['driver'] ? (fleetMapObj[data['driver']] ? fleetMapObj[data['driver']] : null) : null;
            delete data.tableData;
            const res = await dispatch(editCarUnique(data, "Update"));
            if (!res.success) {
              setLoading(false);
              setCommonAlert({ open: true, msg: res.error === 'plate_already_exists' ? t('plate_already_exists') : t('reg_error') });
              return;
            }
            if (data.driver !== oldData.driver && oldData.driver && oldData.active) {
              dispatch(updateUserCar(oldData.driver,
                {
                  carType: null,
                  vehicleNumber: null,
                  vehicleMake: null,
                  vehicleModel: null,
                  other_info: null,
                  car_image: null,
                  placa: null,
                  vehicleColor: null,
                  updateAt: new Date().getTime(),
                })
              );
            }
            setLoading(false);
            navigate("/cars",{state:{pageNo:state?.pageNo}});
          } else {
            setLoading(false);
            setCommonAlert({ open: true, msg: t("make_changes_to_update") });
          }
        }, 600);
      })
      : new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          setLoading(false);
          setCommonAlert({ open: true, msg: t("demo_mode") });
        }, 600);
      });
  };

  const addCar = () => {
    if (settings.AllowCriticalEditsAdmin) {
      if (!data.vehicleMake) {
        setCommonAlert({ open: true, msg: t("vehicleMake_required") });
      } else if (!data.vehicleModel) {
        setCommonAlert({ open: true, msg: t("vehicleModel_required") });
      } else if (!data.placa) {
        setCommonAlert({ open: true, msg: t("placa_required") });
      } else if (!data.vehicleColor) {
        setCommonAlert({ open: true, msg: t("vehicle_color_required") });
      } else if (!data.driver) {
        setCommonAlert({ open: true, msg: t("driver_required") });
      } else if (!data.carType) {
        setCommonAlert({ open: true, msg: t("carType_required") });
      } else {
        setLoading(true);
        new Promise(resolve => {
          setTimeout(async () => {
            let activeCar = null;
            let updateData = {
              carType: data.carType,
              vehicleNumber: data.vehicleNumber,
              vehicleMake: data.vehicleMake,
              vehicleModel: data.vehicleModel,
              other_info: data.other_info,
              car_image: data.car_image,
              placa: data.placa,
              vehicleColor: data.vehicleColor,
              manufactureYear: data.manufactureYear || "",
              city: data.city || "",
              updateAt: new Date().getTime()
            };
            for (let i = 0; i < carData.length; i++) {
              if (carData[i].driver === data.driver && carData[i].active) {
                activeCar = carData[i];
                break;
              }
            }
            let deactivateActive = false;
            let shouldDenorm = false;
            if (activeCar && data.active) {
              activeCar.active = false;
              deactivateActive = true;
              shouldDenorm = true;
            } else if (activeCar && !data.active) {
              data.active = false;
            } else {
              data.active = true;
              shouldDenorm = true;
            }
            data['createdAt'] = new Date().getTime();
            data['fleetadmin'] = data['driver'] ? (fleetMapObj[data['driver']] ? fleetMapObj[data['driver']] : null) : null;
            if (!settings.carApproval) {
              data['approved'] = true;
            } else {
              data['approved'] = false;
            }

            // Reserva atômica da placa + cria o carro (bloqueia se placa duplicada)
            const res = await dispatch(editCarUnique(data, "Add"));
            if (!res.success) {
              setLoading(false);
              setCommonAlert({ open: true, msg: res.error === 'plate_already_exists' ? t('plate_already_exists') : t('reg_error') });
              resolve();
              return;
            }

            if (deactivateActive) {
              dispatch(editCar(activeCar, "Update"));
            }
            if (shouldDenorm) {
              dispatch(updateUserCar(data.driver, updateData));
            }
            if (!settings.carApproval && data.active) {
              dispatch(updateUserCar(data.driver, { carApproved: true }));
            }
            navigate("/cars");
            setLoading(false);
            resolve();
          }, 600);
        })

      }
    }else{
      setCommonAlert({ open: true, msg: t('demo_mode') });
      setLoading(false);
    }
  };


  return loading ? (
    <CircularLoading />
  ) : (
    <>
      <div>
        <Card
          style={{
            borderRadius: "19px",
            backgroundColor: colors.WHITE,
            minHeight: 100,
            maxWidth: "75vw",
            marginTop: 20,
            marginBottom: 20,
            padding: 20,
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
          }}
        >
          <Typography
            variant="h5"
            style={{
              margin: "10px 10px 0 5px",
              textAlign: isRTL === "rtl" ? "right" : "left",
              fontFamily: FONT_FAMILY,
            }}
          >
            {id ? t("update_car_title") : t("add_car_title")}
          </Typography>
    
          <GoBackButton isRTL={isRTL}   onClick={() => { navigate("/cars",{state:{pageNo:state?.pageNo}}); }} />
          <Grid
            container
            spacing={2}
            sx={{
              gridTemplateColumns: "50%",
              rowGap: "20px",
              marginY: 1,
              direction:isRTL === "rtl" ? "rtl" : "ltr",
            }}
          >
            {/* Placa — primeiro campo: pesquisa automática ao digitar 7 caracteres */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("placa")}
                id={"placa"}
                value={data?.placa || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handlePlacaChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                helperText={
                  integrationDetails?.plates?.enabled
                    ? placaFilled
                      ? t("placa_autofilled")
                      : t("placa_helper")
                    : undefined
                }
                FormHelperTextProps={{
                  style: {
                    color: placaFilled ? "#388e3c" : "#888",
                    fontFamily: FONT_FAMILY,
                    fontSize: "11px",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {placaLoading ? (
                        <CircularProgress size={18} thickness={4} style={{ color: MAIN_COLOR }} />
                      ) : placaFilled ? (
                        <Tooltip title={t("placa_autofilled")}>
                          <CheckCircleOutlineIcon style={{ color: "#388e3c", fontSize: 20 }} />
                        </Tooltip>
                      ) : null}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                 InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("vehicle_reg_no")}
                id={"vehicleNumber"}
                value={data?.vehicleNumber || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={
                  isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                 InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("vehicle_model_name")}
                id={"vehicleMake"}
                value={data?.vehicleMake || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                 InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("vehicle_model_no")}
                id={"vehicleModel"}
                value={data?.vehicleModel || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={
                  isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
                }
              />
            </Grid>

            {/* RENAVAM */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("renavam")}
                id={"renavam"}
                value={data?.renavam || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>

            {/* Cor do Veiculo */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("vehicle_color")}
                id={"vehicleColor"}
                value={data?.vehicleColor || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>

            {/* CRLV-e */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("crlve")}
                id={"crlve"}
                value={data?.crlve || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>
            {/* Version */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("version")}
                id={"version"}
                value={data?.version || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>
            {/* Ano */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("manufacture_year")}
                id={"manufactureYear"}
                type={"number"}
                value={data?.manufactureYear || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>
            {/* Cidade */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("city")}
                id={"city"}
                value={data?.city || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>
            {/* Capacity in kg */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("capacity_kg")}
                id={"capacity"}
                value={data?.capacity || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>
            {/* Chassis */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("chassis")}
                id={"chassis"}
                value={data?.chassis || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
              />
            </Grid>

            {/* State Dropdown */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                <InputLabel className={isRTL === "rtl" ? classes.right : ""}>{t("state")}</InputLabel>
                <Select
                  value={data?.state || ""}
                  label={t("state")}
                  onChange={e => setData({ ...data, state: e.target.value })}
                  disabled={data?.active ? true : false}
                  className={isRTL === "rtl" ? classes.selectField_rtl_1 : classes.selectField}
                >
                  {["acre_ac","alagoas_al","amapa_ap","amazonas_am","bahia_ba","ceara_ce","distrito_federal_df","espirito_santo_es","goias_go","maranhao_ma","mato_grosso_mt","mato_grosso_do_sul_ms","minas_gerais_mg","para_pa","paraiba_pb","parana_pr","pernambuco_pe","piaui_pi","rio_de_janeiro_rj","rio_grande_do_norte_rn","rio_grande_do_sul_rs","rondonia_ro","roraima_rr","santa_catarina_sc","sao_paulo_sp","sergipe_se","tocantins_to"].map(key => (
                    <MenuItem key={key} value={key} style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                      <Typography className={classes.typography}>{t(key)}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Fuel Dropdown */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                <InputLabel className={isRTL === "rtl" ? classes.right : ""}>{t("fuel")}</InputLabel>
                <Select
                  value={data?.fuel || ""}
                  label={t("fuel")}
                  onChange={e => setData({ ...data, fuel: e.target.value })}
                  disabled={data?.active ? true : false}
                  className={isRTL === "rtl" ? classes.selectField_rtl_1 : classes.selectField}
                >
                  {["alcool_etanol","alcool_gasolina_flex","gasolina","gas_natural_gnv","diesel","hidrogenio","eletrico"].map(key => (
                    <MenuItem key={key} value={key} style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                      <Typography className={classes.typography}>{t(key)}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Bodywork Dropdown */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                <InputLabel className={isRTL === "rtl" ? classes.right : ""}>{t("bodywork")}</InputLabel>
                <Select
                  value={data?.bodywork || ""}
                  label={t("bodywork")}
                  onChange={e => setData({ ...data, bodywork: e.target.value })}
                  disabled={data?.active ? true : false}
                  className={isRTL === "rtl" ? classes.selectField_rtl_1 : classes.selectField}
                >
                  {["nao_aplicavel","aberta","fechada_bau","granelera","porta_conteiner","sider"].map(key => (
                    <MenuItem key={key} value={key} style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                      <Typography className={classes.typography}>{t(key)}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Vehicle Type Dropdown */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                <InputLabel className={isRTL === "rtl" ? classes.right : ""}>{t("vehicle_type")}</InputLabel>
                <Select
                  value={data?.vehicleType || ""}
                  label={t("vehicle_type")}
                  onChange={e => setData({ ...data, vehicleType: e.target.value })}
                  disabled={data?.active ? true : false}
                  className={isRTL === "rtl" ? classes.selectField_rtl_1 : classes.selectField}
                >
                  {["nao_aplicavel","tracao","reboque","semirreboque","carga","passeio","utilitario","passageiro","misto","especial","motocicleta_motoneta","quadriciclo","trator","blindado"].map(key => (
                    <MenuItem key={key} value={key} style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                      <Typography className={classes.typography}>{t(key)}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* Wheel Type Dropdown */}
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                <InputLabel className={isRTL === "rtl" ? classes.right : ""}>{t("wheel_type")}</InputLabel>
                <Select
                  value={data?.wheelType || ""}
                  label={t("wheel_type")}
                  onChange={e => setData({ ...data, wheelType: e.target.value })}
                  disabled={data?.active ? true : false}
                  className={isRTL === "rtl" ? classes.selectField_rtl_1 : classes.selectField}
                >
                  {["bitrem_rodotrem","bitruck","carreta_cavalo_trucado","carreta_ls_linha_seta","carreta_simples","cavalo_mecanico","cavalo_mecanico_trucado","nao_aplicavel","outros","romeu_e_julieta","toco","truco","utilitarios","van"].map(key => (
                    <MenuItem key={key} value={key} style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}>
                      <Typography className={classes.typography}>{t(key)}</Typography>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                 InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                label={t("other_info")}
                id={"other_info"}
                value={data?.other_info || ""}
                disabled={data?.active ? true : false}
                fullWidth
                onChange={handleInputChange}
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl
                fullWidth
                style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  className={isRTL === "rtl" ? classes.right : ""}
                  sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}
                >
                  {<Typography className={classes.typography}>{t("driver")}</Typography>}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={
                    role === "fleetadmin"
                      ? driversObj[data?.driver] || ""
                      : role === "driver"
                        ? auth.profile.id || ""
                        : role === "admin"
                          ? driversObj[data?.driver] || ""
                          : ""
                  }
                  disabled={role === "driver" ? true : false}
                  label={t("driver")}
                  onChange={handelChangeDriver}
                  className={
                    isRTL === "rtl"
                      ? classes.selectField_rtl
                      : classes.selectField
                  }
                >
                  {role === "admin" ? (
                    drivers ? (
                      drivers.map((e) => (
                        <MenuItem
                          key={e.id}
                          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                          value={driversObj[e.id] || ""}
                        >
                          {<Typography className={classes.typography}>{e.desc}</Typography>}
                        </MenuItem>
                      ))
                    ) : null
                  ) : role === "driver" ? (
                    <MenuItem
                      style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                      value={auth.profile.id || ""}
                    >
                      {<Typography className={classes.typography}>{driverData}</Typography>}
                    </MenuItem>
                  ) : role === "fleetadmin" ? (
                    drivers ? (
                      drivers.map((e) => (
                        <MenuItem
                          key={e.id}
                          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                          value={driversObj[e.id] || ""}
                        >
                          {<Typography className={classes.typography}>{e.desc}</Typography>}
                        </MenuItem>
                      ))
                    ) : null
                  ) : null}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl
                fullWidth
                style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  className={isRTL === "rtl" ? classes.right : ""}
                  sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}
                >
                  {<Typography className={classes.typography}>{t("car_type")}</Typography>}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={data?.carType || ""}
                  label={t("car_type")}
                  onChange={handelChangeCarType}
                  disabled={data?.active ? true : false}
                  className={
                    isRTL === "rtl"
                      ? classes.selectField_rtl_1
                      : classes.selectField
                  }
                >
                  {!carTypeAvailable ? (
                    <MenuItem
                      value={oldData?.carType}
                      style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                    >
                      {<Typography className={classes.typography}>{t(getLangKey(oldData?.carType ? oldData?.carType : ""))}</Typography>}
                    </MenuItem>
                  ) : null}
                  {cartypes?.cars
                    ? cartypes.cars.map((e) => (
                      <MenuItem
                        key={e.id}
                        value={e.name}
                        style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                      >
                        {<Typography className={classes.typography}>{t(getLangKey(e.name ? e.name : ""))}</Typography>}
                      </MenuItem>
                    ))
                    : null}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={ 12}
              display="flex"
              justifyContent="center"
              alignItems="center">
              <Button
                style={{
                  borderRadius: "19px",
                  backgroundColor: MAIN_COLOR,
                  minHeight: 50,
                  width: (isMidScreen ? '100%' :  '50%'),
                  textAlign: "center",
                }}
                onClick={()=>{
                  if(id){
                    updateCar();
                  }else{
                    addCar();
                  }
                }}
                variant="contained"
              >
                <Typography
                  style={{
                    color: colors.WHITE,
                    textAlign: "center",
                    fontSize: 16,
                    fontWeight: "bold",
                    fontFamily: FONT_FAMILY,
                  }}
                >
                  {id ? t("update") : t("add")}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Card>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
      </div>
    </>
  );
}

export default EditCar;